import React from 'react'
import { parseMillisecondsToHoursAndMinutes } from '../../../../helpers/helpers'
import PermanenceTotals from '../PermanenceTotals';
import { t } from 'i18next';

const PermanenceTotalsDetailSimple = ({ totalsReport, codeKey, descriptionKey }) => {

    const totals = {
        hs_50: totalsReport.hs_50,
        hs_100: totalsReport.hs_100,
        hs_normal: totalsReport.hs_normal
    };

    return (
        <div>
            <div
                className='pe-4 ps-4 d-flex justify-content-between align-items-center h-100 pt-2 pb-2'
                style={{ background: '#EFF7FE' }}
            >
                <h5 className='dark-text'>
                    {totalsReport[codeKey] && (`${totalsReport[codeKey]} - `)}{totalsReport[descriptionKey] ? totalsReport[descriptionKey] : t('NO_ASSIGNMENT')}
                </h5>
                <h4 className='blue-text'>
                    {Number(parseMillisecondsToHoursAndMinutes(totalsReport.hs_total).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(totalsReport.hs_total).split(':')[1])}min
                </h4>
            </div>
            <div className='pe-4 ps-4'>
                <PermanenceTotals
                    haveDetail={false}
                    borders=''
                    totals={totals}
                    alingment='justify-content-between'
                />
            </div>
        </div>
    )
}

export default PermanenceTotalsDetailSimple